import { forwardRef } from 'react';

import { IconProps } from '@sternum/web/icons/icons.types';

export const SearchIcon = forwardRef<SVGSVGElement, IconProps>(function LockIcon(
  { color = '', height = 18, width = 18, ...props },
  ref,
) {
  return (
    <svg
      ref={ref}
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5814 1.25581C4.53559 1.25581 1.25581 4.53559 1.25581 8.5814C1.25581 12.6272 4.53559 15.907 8.5814 15.907C12.6272 15.907 15.907 12.6272 15.907 8.5814C15.907 4.53559 12.6272 1.25581 8.5814 1.25581ZM0 8.5814C0 3.84202 3.84202 0 8.5814 0C13.3208 0 17.1628 3.84202 17.1628 8.5814C17.1628 13.3208 13.3208 17.1628 8.5814 17.1628C3.84202 17.1628 0 13.3208 0 8.5814Z"
        fill={color || 'currentColor'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.2537 15.2537C15.4989 15.0085 15.8965 15.0085 16.1417 15.2537L17.8161 16.9281C18.0613 17.1733 18.0613 17.5709 17.8161 17.8161C17.5709 18.0613 17.1733 18.0613 16.9281 17.8161L15.2537 16.1417C15.0085 15.8965 15.0085 15.4989 15.2537 15.2537Z"
        fill={color || 'currentColor'}
      />
    </svg>
  );
});
